var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorShades = function SvgColorShades(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.897c0 .923-.3 1.744-.9 2.462-.2.308-.5.513-.7.718-.7.513-1.6.923-2.7.923C4.8 18 3 16.154 3 13.897 3 11.641 4.2 9.59 5.4 7.95 6 7.23 6.6 6.615 7.1 6.103L7.2 6l.1.103c.5.41 1.1 1.025 1.7 1.846.4.41.8.923 1 1.436.2.307.4.718.6 1.025.6 1.026.9 2.257.9 3.487Z",
    fill: "#F4BD38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7 10.41c-.2-.41-.4-.718-.6-1.025-.3-.513-.6-.923-1-1.334-.6-.82-1.2-1.436-1.7-1.846 0-.102-.1-.205-.1-.205l-.1.103c-.5.41-1.1 1.025-1.7 1.846-.3.41-.7.82-1 1.333.8 1.333 1.3 2.974 1.3 4.615 0 1.231-.4 2.36-1.2 3.18.7.513 1.6.923 2.7.923s1.9-.308 2.7-.923c.3-.205.5-.41.7-.718.6-.718.9-1.539.9-2.462-.1-1.23-.4-2.461-.9-3.487Z",
    fill: "#37AFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.602 13.846c0 2.257-1.9 4.103-4.2 4.103-1 0-1.9-.308-2.7-.923.7-.82 1.2-1.95 1.2-3.18 0-1.64-.5-3.18-1.3-4.513.3-.513.6-.923.9-1.333.6-.82 1.2-1.436 1.7-1.846l.1-.103.1.103c.5.41 1.1 1.025 1.7 1.846 1.3 1.538 2.5 3.59 2.5 5.846Z",
    fill: "#DA2A3C"
  })));
};
export default SvgColorShades;